import { Logger, LogLevel } from "../services/Logger";

interface AsyncQueueDelegate<T> {
  Flush(queue: T[]): Promise<boolean>;
}

class AsyncQueue<T> {
  private queue: T[] = [];
  private readonly debounce: number;
  private flushTimeout: undefined | number = undefined;
  private delegate: AsyncQueueDelegate<T>;

  constructor(debounce: number, delegate: AsyncQueueDelegate<T>) {
    this.debounce = debounce;
    this.delegate = delegate;
  }

  public Push(item: T): void {
    this.queue.push(item);

    window.clearTimeout(this.flushTimeout);
    this.flushTimeout = window.setTimeout(() => this.DoFlush(), this.debounce);
  }

  public DoFlush(): void {
    var queue = [...this.queue];
    this.queue = [];

    //Don't bother flushing the queue if there's nothing to flush
    if (queue.length === 0) return;

    this.delegate.Flush(queue).then((didFlush) => {
      //If the queue was not flushed, add the items back
      if (!didFlush) this.queue = [...queue, ...this.queue];
    }).catch((err) => {
      //Same thing here, add the items back to the queue to be tried again later
      this.queue = [...queue, ...this.queue];

      Logger.Log(LogLevel.Error, '[Async Queue]', 'Failed to flush queue', this.queue, err);
    });
  }
}

export { AsyncQueue, AsyncQueueDelegate }
